import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class BrowserRequest extends Component {
    static contextTypes = {
        theme: PropTypes.string,
    };

    render() {
        return (
            <div className={styles.root}>
                <div className={styles.box}>
                    <div className={styles.icon}>!</div>
                    {_('Por favor, abrir', { context: 'browser_request' })}
                    <div className={classNames(styles.url, styles.fill, styles[this.context.theme])}>
                        {settings.app.domain}
                    </div>
                    {_('con {{browser}}', { browser: this.props.browser, context: 'browser_request' })}
                </div>
            </div>
        );
    }
}
